// Which outlets this reader is watching.
//
// The App Store rejection under Guideline 4.2.2 turned on the app being
// indistinguishable from browsing the site. A watchlist is the clearest answer to
// that: the feed a reader sees is assembled on their device from their own
// choices and persists across launches — the website shows everyone the same
// chronological list.
//
// Kept device-local on purpose: the app has no accounts, and a watchlist is
// not worth asking someone to register for.

const KEY = "btn-watched-outlets";

function read() {
  try {
    const raw = localStorage.getItem(KEY);
    const list = raw ? JSON.parse(raw) : [];
    return Array.isArray(list) ? list.filter((x) => typeof x === "string") : [];
  } catch (e) {
    return [];
  }
}

function write(list) {
  try {
    localStorage.setItem(KEY, JSON.stringify(list));
  } catch (e) {
    // private mode — the watchlist simply doesn't persist
  }
  // Every mounted screen that filters by the watchlist listens for this.
  try {
    window.dispatchEvent(new Event("btn-watchlist-changed"));
  } catch (e) {}
}

export function getWatched() {
  return read();
}

export function isWatched(outlet) {
  return read().includes(String(outlet || "").toLowerCase());
}

export function toggleWatched(outlet) {
  const key = String(outlet || "").toLowerCase();
  if (!key) return read();
  const list = read();
  const next = list.includes(key) ? list.filter((x) => x !== key) : [...list, key];
  write(next);
  return next;
}

export function clearWatched() {
  write([]);
}

export const WATCHLIST_EVENT = "btn-watchlist-changed";
